import {createSlice} from '@reduxjs/toolkit';
import {getHistoryPhysicalMiddleWare} from './historyPhysicalMiddleware';
import {HealthAndPhysicalReducerState} from './historyPhysicalTypes';

const getUserInitialState: HealthAndPhysicalReducerState = {
  isLoading: false,
  error: '',
};

const getHistoryPhysicalReducer = createSlice({
  name: 'getHistoryPhysical',
  initialState: getUserInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getHistoryPhysicalMiddleWare.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(getHistoryPhysicalMiddleWare.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getHistoryPhysicalMiddleWare.rejected, (state, action) => {
      state.isLoading = false;
      if (typeof action.payload === 'string') {
        state.error = action.payload;
      }
    });
  },
});

export const getHistoryPhysicalReducers = getHistoryPhysicalReducer.reducer;
